<div class="gl-dashboard__title group">
  {{ 'dashboard.widgets.autoevaluationCourse' | translate }}
  <gl-tooltip posTop [text]="'dashboard.widgets.autoevaluationCourseTooltip' | translate"></gl-tooltip>
</div>
<div class="gl-dashboard__block autoevaluations">
  <lms-autoevaluationCourses
    *ngIf="autoevaluations"
    [data]="autoevaluations"
    disabledHeader="true"
  ></lms-autoevaluationCourses>
</div>
